import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import { FC, useCallback } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state';
import { useRouter } from 'next/router';
import { ValidationTypes } from '@/constants/offers';
import { CloseButton } from '@/components/shared/close-button';
import ImageBoxFuture from '@/components/shared/image-box-future';

export const NotAvailableOfferInfoDialog: FC = () => {
  const theme = useTheme();
  const intl = useIntl();
  const router = useRouter();
  const [dialog, setDialog] = useDialog(s => [s.dialog, s.setDialog], shallow);

  const handleOkayClick = useCallback(() => {
    setDialog({});
    router.push('/');
  }, [router, setDialog]);

  return (
    <>
      <DialogTitle>
        <CloseButton handleClick={handleOkayClick} />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            alignItems: 'center',
            margin: 'auto',
            textAlign: 'center',
          }}
        >
          <Stack
            sx={{
              alignItems: 'center',
              marginBlock: 4,
            }}
            spacing='4px'
          >
            <ImageBoxFuture
              img={dialog?.notAvailableOfferInfoDialogPayload?.img}
              title={
                dialog?.notAvailableOfferInfoDialogPayload?.logoUrlAlt ||
                intl.formatMessage({
                  id: 'alt.not_available_offer',
                })
              }
              objectFit='cover'
              sx={{
                borderRadius: '5px',
                overflow: 'hidden',
                width: '87px',
                height: '44px',
              }}
            />

            <Typography
              component='span'
              sx={{
                fontSize: {
                  mobile: '14px',
                  tablet: pxToRem(16),
                },
                fontFamily: theme.palette.typography.font.bold,
                lineHeight: '24px',
                color: theme.palette.grey[80],
              }}
            >
              {dialog?.notAvailableOfferInfoDialogPayload?.validationType ===
              ValidationTypes.BIN
                ? dialog?.notAvailableOfferInfoDialogPayload?.bankName
                : dialog?.notAvailableOfferInfoDialogPayload?.hint}
            </Typography>
            <Typography
              component='span'
              sx={{
                fontSize: {
                  mobile: '13px',
                  tablet: pxToRem(14),
                },
                lineHeight: {
                  tablet: pxToRem(24),
                },
                color: theme.palette.grey[50],
              }}
            >
              {dialog?.notAvailableOfferInfoDialogPayload?.title}
            </Typography>
          </Stack>
          <Typography
            sx={{
              color: theme.palette.grey[90],
              fontSize: pxToRem(22),
              fontWeight: 700,
              lineHeight: '33px',
              marginBottom: pxToRem(24),
            }}
          >
            <FormattedMessage id='offers.not_available_offer_info_dialog.title' />
          </Typography>
          <Typography
            sx={{
              color: theme.palette.grey[70],
              fontSize: pxToRem(18),
              fontWeight: 400,
              lineHeight: '27px',
              textAlign: 'center',
            }}
          >
            <FormattedMessage id='offers.not_available_offer_info_dialog.description' />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          id='not-available-offer-info-dialog-okay'
          variant='contained'
          fullWidth
          onClick={handleOkayClick}
          sx={{ height: { tablet: pxToRem(56), mobile: '56px' } }}
        >
          <FormattedMessage id='global.okay' />
        </Button>
      </DialogActions>
    </>
  );
};
